export const deviceName = (id, snapshot, devices = []) => devices.find((device) => device.deviceId === id)?.name
  || snapshot?.devices?.find((device) => device.deviceId === id)?.name
  || snapshot?.targets?.find((device) => device.deviceId === id)?.name || 'Unavailable device';

export function versionParts(version) {
  const match = typeof version === 'string' && version.match(/^(\d{1,5})\.(\d{1,5})\.(\d{1,5})(?:-legacy)?(?:-dev)?$/);
  return match ? match.slice(1, 4).map(Number) : null;
}

export function compareVersions(a, b) {
  const left = versionParts(a); const right = versionParts(b);
  if (!left || !right) return left ? 1 : right ? -1 : 0;
  for (let i = 0; i < 3; i++) if (left[i] !== right[i]) return left[i] - right[i];
  return 0;
}

export const versionChannel = (version) => typeof version === 'string' ? version.endsWith('-dev') ? 'debug' : 'prod' : null;

export function recentUpdateResults(jobs) {
  const sorted = [...jobs].sort((a, b) => (b.createdAtEpochMs || 0) - (a.createdAtEpochMs || 0));
  const attention = sorted.filter((job) => ['queued', 'running'].includes(job.status));
  const latest = new Map();
  const protectedTargets = new Set(attention.map((job) => job.targetDeviceId));
  for (const job of sorted) {
    if (!protectedTargets.has(job.targetDeviceId) && !latest.has(job.targetDeviceId)) latest.set(job.targetDeviceId, job);
  }
  // Keep active updates visible; old failures never override a newer result.
  return [...attention, ...[...latest.values()].slice(0, 10)];
}
